
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

interface Benefit {
  icon: React.ReactElement;
  title: string;
  description: string;
}

interface BenefitsCarouselSectionProps {
  title: string;
  subtitle: string;
  benefits: Benefit[];
}

const BenefitsCarouselSection: React.FC<BenefitsCarouselSectionProps> = ({
  title,
  subtitle,
  benefits
}) => {
  return (
    <section className="py-20 bg-[#072c39] text-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            {title}
          </h2>
          <p className="text-drcash-cadet-gray max-w-2xl mx-auto">
            {subtitle}
          </p>
          <div className="h-1 w-20 bg-gradient-to-r from-drcash-caribbean-green to-drcash-tiffany-blue rounded-full mx-auto mt-6"></div>
        </div>
        
        <div className="max-w-6xl mx-auto">
          <Carousel className="w-full">
            <CarouselContent>
              {benefits.map((benefit, index) => (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3 pl-4">
                  <Card className="bg-white/5 backdrop-blur-sm border-white/10 h-full">
                    <CardHeader>
                      <div className="mb-4">
                        {benefit.icon}
                      </div>
                      <CardTitle className="text-white text-xl">{benefit.title}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-drcash-cadet-gray">{benefit.description}</p>
                    </CardContent>
                  </Card>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-center mt-8 gap-4">
              <CarouselPrevious className="relative inset-0 translate-y-0 bg-white/10 hover:bg-white/20 border-0" />
              <CarouselNext className="relative inset-0 translate-y-0 bg-white/10 hover:bg-white/20 border-0" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default BenefitsCarouselSection;
